import React, {useEffect} from 'react';
import PageWidthLayout from "../components/common/PageWidthLayout";
import LoginForm from "../components/login/LoginForm";

function LoginPage() {

    useEffect(() => {
        const scrollPosition = sessionStorage.getItem('scrollPosition');
        if (scrollPosition) {
            window.scrollTo(0, parseInt(scrollPosition));
            sessionStorage.removeItem('scrollPosition');
        } else {
            window.scrollTo(0, 0);
        }
    }, []);

    return (
        <div className="overflow-hidden relative bg-cyan-50">
            {/* Background image overlay */}
            <div style={{
                backgroundImage: 'url(https://i.ibb.co/9kYFDXtW/background-manga.jpg)',
                backgroundSize: 'cover',
                opacity: 0.04,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0
            }}></div>

            {/* Main content (placed above background) */}
            <div className="relative z-10">
                <div className="h-6 bg-cyan-50"></div>

                <div className="flex justify-center min-h-screen">
                    <div className="mt-2">
                        <div className="mx-3">
                            <LoginForm />
                        </div>

                        <div><PageWidthLayout/></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;